module.exports = __webpack_public_path__ + "img/calendar.751d2167.svg";